// Outreach topics for the Alerts "Draft Outreach" section.
//
// The `value`s must match EmailDraftService::TOPICS in alps-be (CR-1716); the
// backend exposes no topics endpoint, so the display labels live here. Kept as a
// FE constant because these are code, not data: each topic is backed by a prompt
// file (app/services/prompts/email_drafts/<topic>.txt) and a TOPIC_CONTEXT entry,
// so adding one already requires a backend change. The controller validates the
// topic and returns 422 `unknown_topic`, so any drift fails loudly.
//
// TODO: swap this for a backend endpoint if the need arises — e.g. topics have to
// be filtered per alert (`re_up` only for existing investors, `advance_commitment`
// only with a commitment in flight — only the backend has that context), or they
// become per-tenant configurable (then they belong in config_lists). Have the
// endpoint return { value, label } pairs so labels aren't re-derived here.
export const OUTREACH_TOPICS = [
	{ value: 're_engage', label: 'Re-Engage' },
	{ value: 're_up', label: 'Re-Up' },
	{ value: 'advance_commitment', label: 'Advance Commitment' },
	{ value: 'meeting_request', label: 'Meeting Request' },
	{ value: 'lp_update', label: 'LP Update' },
];
